import { computed, Directive, effect, ElementRef, inject, Provider, SkipSelf } from '@angular/core';

import { TELLENT_ADOPTED_STYLESHEETS, TellentAdoptedStylesheetsSignal } from '@core/tellent-types';

const tagsReported = new Set();

@Directive({
  standalone: true,
  selector: '[tellentAdoptedStylesheets]',
})
export class TellentAdoptedStylesheetsDirective {
  private readonly sheets = inject(TELLENT_ADOPTED_STYLESHEETS);
  private readonly elRef = inject(ElementRef<HTMLElement>);

  constructor() {
    effect(() => {
      const tagName = this.elRef.nativeElement.tagName.toLowerCase();
      if (this.elRef.nativeElement.shadowRoot) {
        this.elRef.nativeElement.shadowRoot.adoptedStyleSheets = this.sheets();
      } else if (!tagsReported.has(tagName)) {
        console.warn(
          `Component "${tagName}" is not shadow-dom encapsulated, skipping adoptedStylesheets.`,
        );
        tagsReported.add(tagName);
      }
    });
  }
}

export function provideUpdatedAdoptedStylesheets(added: CSSStyleSheet[]): Provider {
  return {
    provide: TELLENT_ADOPTED_STYLESHEETS,
    useFactory: (existingStylesheets: TellentAdoptedStylesheetsSignal) =>
      computed(() => [...existingStylesheets(), ...added]),
    deps: [[new SkipSelf(), TELLENT_ADOPTED_STYLESHEETS]],
  };
}
